"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSwitcher = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const locale_1 = require("../../../../utils/locale");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'language-switcher';
const localeItems = {
    en: {
        name: 'EN',
        iconName: 'en',
    },
    de: {
        name: 'DE',
        iconName: 'de',
    },
    sq: {
        name: 'AL',
        iconName: 'al',
    },
    fr: {
        name: 'FR',
        iconName: 'fr',
    },
};
const LanguageSwitcher = (props) => {
    var _a;
    const { modificators, onLanguageChange, selectedLanguage, } = props;
    const [active, setActive] = (0, react_1.useState)((_a = locale_1.allLocales.find(x => x === selectedLanguage)) !== null && _a !== void 0 ? _a : locale_1.allLocales[0]);
    const notSelectedItems = locale_1.allLocales.filter(x => x !== active);
    return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(className, modificators) },
        react_1.default.createElement("div", { className: `${className}__selected` },
            react_1.default.createElement("div", { className: `${className}__selected-flag` },
                react_1.default.createElement(Icon_1.Icon, { name: localeItems[active].iconName })),
            react_1.default.createElement("div", { className: `${className}__selected-value` }, localeItems[active].name),
            react_1.default.createElement("div", { className: `${className}__arrow` },
                react_1.default.createElement(Icon_1.Icon, { name: 'arrow-right' }))),
        react_1.default.createElement("div", { className: `${className}__dropdown` },
            react_1.default.createElement("div", { className: `${className}__dropdown-list` },
                react_1.default.createElement("div", { className: `${className}__list-arrow` }),
                notSelectedItems.map(locale => (react_1.default.createElement("div", { className: `${className}__language`, key: locale, onClick: () => {
                        onLanguageChange(locale);
                        setActive(locale);
                    } },
                    react_1.default.createElement("div", { className: `${className}__language-flag` },
                        react_1.default.createElement(Icon_1.Icon, { name: localeItems[locale].iconName })),
                    react_1.default.createElement("div", { className: `${className}__language-value` }, localeItems[locale].name))))))));
};
exports.LanguageSwitcher = LanguageSwitcher;
//# sourceMappingURL=index.js.map